module.exports = __webpack_public_path__ + "static/media/snapchat-social-media-svgrepo-com.bb4a6f22.svg";